/**
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ClrModalModule } from "../modal/modal.module";
import { ClrAlertModule } from "../emphasis/alert/alert.module";
import { WIZARD_DIRECTIVES } from "./index";
var ClrWizardModule = (function () {
    function ClrWizardModule() {
    }
    return ClrWizardModule;
}());
export { ClrWizardModule };
ClrWizardModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule,
                    ClrModalModule,
                    ClrAlertModule
                ],
                declarations: [
                    WIZARD_DIRECTIVES
                ],
                exports: [
                    WIZARD_DIRECTIVES
                ]
            },] },
];
/** @nocollapse */
ClrWizardModule.ctorParameters = function () { return []; };
//# sourceMappingURL=wizard.module.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/wizard/wizard.module.js
// module id = 225
// module chunks = 4